// extracted by mini-css-extract-plugin
module.exports = {"hidden":"mainTopArea_hidden__9cQji","textEmphasis":"mainTopArea_textEmphasis__FxBtw","mainTopInner":"mainTopArea_mainTopInner__8NxVe"};